export default {
  addCalendarEvent: () => `/calendar-events`,
  getCalendarEvent: () => `/calendar-events/events`,
  getCompliance: () => `/calendar-events/compliance`,
  getComplianceByEmployeeId: (employeeId) => `/calendar-events/employees/${employeeId}/compliance`,
  getCalendarEventByEmployeeId: employeeId => `/calendar-events/employees/${employeeId}/events`,
  updateCalendarEvent: id => `/calendar-events/${id}`,
  deleteCalendarEvent: id => `/calendar-events/${id}`,
  getEmployeeAvailableList: supervisorId => `/calendar-events/supervisors/${supervisorId}/events`,
};
